export default "__VITE_PUBLIC_ASSET__1049213a__"